$(document).ready(function () {
  $(document).on("click", ".js-qty__wrapper_custom button.js-qty__adjust.js-qty__adjust--plus_custom", function () {
      var get_val = parseInt($(this).parents(".js-qty__wrapper_custom").find("input").val()) + parseInt("1");
      $(this).parents(".js-qty__wrapper_custom").find("input").val(get_val);
  });
  $(document).on("click", ".js-qty__wrapper_custom button.js-qty__adjust.js-qty__adjust--minus_custom", function () {
      var get_val = $(this).parents(".js-qty__wrapper_custom").find("input").val() - 1;
      if (get_val != 0) {
          $(this).parents(".js-qty__wrapper_custom").find("input").val(get_val);
      }
  });
  $(document).on("click", ".cart-upsell-inner-wrappp .upsell_cart_btn button", function () {
      var pro_id = $(this).attr("data-id");
      var pro_qty = $(this).parents(".upsell_products_inner").find(".upsell_qty_price_wrapp .js-qty__num").val();
      $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: { id: pro_id, quantity: pro_qty },
          dataType: "json",
          success: function (data) {
              document.dispatchEvent(new CustomEvent("cart:build"));
          },
          error: function (jqXHR, textStatus, errorThrown) {
              console.log("error");
          },
      });
  });
});

function checkFormCompletion() {
    const operation = document.getElementById("operation");
    const fundOrigin = document.getElementById("fund_origin");
    const fundDestination = document.getElementById("fund_destination");
    const submitButton = document.getElementById("myBtn");
    if (!operation || !fundOrigin || !fundDestination || !submitButton) return;
    function validateGroup(selectEl) {
        const val = selectEl.value;
        const wrapper = selectEl.closest('.dropdown-options').querySelector('.input_MetaText_wp');
        const textInput = wrapper.querySelector('input');
        if (val === 'Autre') {
            wrapper.classList.remove('hide');
            return textInput.value.trim() !== "";
        } else {
            wrapper.classList.add('hide');
            return val !== "" && val !== null;
        }
    }
    const isOpValid = validateGroup(operation);
    const isOriginValid = validateGroup(fundOrigin);
    const isDestValid = validateGroup(fundDestination);
    if (isOpValid && isOriginValid && isDestValid) {
        submitButton.classList.remove("dropactive");
    } else {
        submitButton.classList.add("dropactive");
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const dropdownIds = ["operation", "fund_origin", "fund_destination"];
    dropdownIds.forEach(id => {
        const select = document.getElementById(id);
        if (select) {
            select.addEventListener('change', checkFormCompletion);
            const textInput = select.closest('.dropdown-options').querySelector('.input_MetaText_wp input');
            if (textInput) {
                textInput.addEventListener('input', checkFormCompletion);
            }
        }
    });

    const operation1 = document.getElementById("operation");
    const fundOrigin1 = document.getElementById("fund_origin");
    const fundDestination1 = document.getElementById("fund_destination");
    const dropdownMain = document.querySelector(".Custom-dropdonw-main");
    const target = document.querySelector(".cart-total_price_wrapp");
    const submitButton = document.getElementById("myBtn");
    // Parse price from the inner text
    function parsePriceFromInnerHTML() {
        if (!target) return 0;

        // Get inner HTML including <sup>
        const htmlContent = target.innerHTML;

        // Extract main part (e.g. "3.006") and remove dots (thousand separators)
        const mainMatch = htmlContent.match(/([\d.]+)/);
        const mainNumber = mainMatch ? mainMatch[1].replace(/\./g, "") : "0";

        // Extract <sup> value (e.g. "00" for cents)
        const supMatch = htmlContent.match(/<sup>(\d+)<\/sup>/);
        const cents = supMatch ? supMatch[1] : "00";

        // Combine into full cents value: "3006" + "00" => 300600
        const totalCents = parseInt(`${mainNumber}${cents}`, 10);

        return isNaN(totalCents) ? 0 : totalCents;
    }

    // Check and update class
    function checkAndUpdateOptions() {
        const price = parsePriceFromInnerHTML();
        console.log("Cart price updated:", price);
        if (price >= 1000000) {
            dropdownMain.classList.remove("hideOptions");
            submitButton.classList.add("dropactive");
        } else {
            dropdownMain.classList.add("hideOptions");
            submitButton.classList.remove("dropactive");
        }
    }

    // ✅ Trigger check after manual price adjustment
    document.addEventListener("cart:priceAdjustTotal", function () {
      setTimeout(checkAndUpdateOptions, 300);
    });

    // ✅ Initial check
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(checkAndUpdateOptions, 3500); // small delay for async cart rendering
    });

    function initialCheckByAttribute() {
        const dropdownMain = document.querySelector(".Custom-dropdonw-main");
        const cartTotalWrapper = document.querySelector(".cart-total_price_wrapp");
        const submitButton = document.getElementById("myBtn");

        const dataTotal = cartTotalWrapper.getAttribute("data-total");
        const total = parseInt(dataTotal, 10); // convert to number

        if (!isNaN(total)) {
            if (total >= 1000000) {
                dropdownMain.classList.remove("hideOptions");
                submitButton.classList.add("dropactive");
            } else {
                dropdownMain.classList.add("hideOptions");
                submitButton.classList.remove("dropactive");
            }
            console.log("Initial check (data-total):", total);
        }
    }

    var firstreload = false;

    if (target) {
        const observer = new MutationObserver(function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === "childList" || mutation.type === "characterData") {
                    // Run check when inner HTML changes
                    if (firstreload) {
                        setTimeout(checkAndUpdateOptions, 300); // Delay in case of async DOM updates
                    }
                }
            }
        });

        observer.observe(target, {
            childList: true,
            characterData: true,
            subtree: true,
        });

        if (!firstreload) {
            setTimeout(() => {
                initialCheckByAttribute();
                firstreload = true;
            }, 3500);
        }
    }

    operation1.addEventListener("change", checkFormCompletion);
    fundOrigin1.addEventListener("change", checkFormCompletion);
    fundDestination1.addEventListener("change", checkFormCompletion);
});


let SubtitalAdjust = 0, finalSubtotalAdjust = 0;
setInterval(() => {
  const subtotalEl = document.querySelector('.main__cart__item-sub--subtotal-adjust');
  const FallBacksubtotalEl = document.querySelector('.main__cart__item-sub--subtotal--adjust').querySelector('.visually-hidden');
  const submitButton = document.getElementById("myBtn");
  const dropdownMain = document.querySelector(".Custom-dropdonw-main");
  if (subtotalEl) {
    SubtitalAdjust = subtotalEl.innerHTML;
    finalSubtotalAdjust = parseInt(
      (SubtitalAdjust.replace(/<[^>]*>/g, "").replace(/[^\d]/g, "") || "0"),
      10
    );
    document.querySelectorAll(`[data-total]`).forEach((el) => {
      el.dataset.total = finalSubtotalAdjust;
    });
    if (finalSubtotalAdjust >= 1000000) {
      dropdownMain.classList.remove("hideOptions");
      const selectWrappers = document.querySelectorAll('.cart_data_upsell_wrapper .dropdown-options');
      let validCount = 0;
      selectWrappers.forEach(wrapper => {
        const select = wrapper.querySelector('select');
        const val = select ? select.value.trim() : "";
        const metaInput = wrapper.querySelector('.input_MetaText_wp input');
        if (val === 'Autre') {
          if (metaInput && metaInput.value.trim() !== "") {
            validCount++;
          }
        } else if (val !== "") {
          validCount++;
        }
      });
      if (validCount === 3) {
        submitButton.classList.remove("dropactive");
      } else {
        submitButton.classList.add("dropactive");
      }
    } else {
      dropdownMain.classList.add("hideOptions");
      submitButton.classList.remove("dropactive");
    }
  }else if(FallBacksubtotalEl){
    SubtitalAdjust = FallBacksubtotalEl.innerHTML;
    finalSubtotalAdjust = parseInt(
      (SubtitalAdjust.replace(/<[^>]*>/g, "").replace(/[^\d]/g, "") || "0"),
      10
    );
    document.querySelectorAll(`[data-total]`).forEach((el) => {
      el.dataset.total = finalSubtotalAdjust;
    });
    if (finalSubtotalAdjust >= 1000000) {
      dropdownMain.classList.remove("hideOptions");
      const selectWrappers = document.querySelectorAll('.cart_data_upsell_wrapper .dropdown-options');
      let validCount = 0;
      selectWrappers.forEach(wrapper => {
        const select = wrapper.querySelector('select');
        const val = select ? select.value.trim() : "";
        const metaInput = wrapper.querySelector('.input_MetaText_wp input');
        if (val === 'Autre') {
          if (metaInput && metaInput.value.trim() !== "") {
            validCount++;
          }
        } else if (val !== "") {
          validCount++;
        }
      });
      if (validCount === 3) {
        submitButton.classList.remove("dropactive");
      } else {
        submitButton.classList.add("dropactive");
      }
    } else {
      dropdownMain.classList.add("hideOptions");
      submitButton.classList.remove("dropactive");
    }
  }
}, 50);

$(document).ready(function () {
  // --- Function: extract visible adjusted price as clean integer ---
  function getVisibleAdjustedPrice() {
    const $adjustDiv = $('.main__cart__item-sub--subtotal-adjust');
    if ($adjustDiv.length) {
      // Example HTML: 3.001<sup>00</sup> €
      const priceText = $adjustDiv.text().trim();
      // Remove non-digits, so "3.00100" -> "300100"
      const numericOnly = priceText.replace(/[^\d]/g, '');
      const finalPrice = parseInt(numericOnly, 10) || 0;

      console.log('💶 Visible final adjusted price:', finalPrice);
      return finalPrice;
    }
    return 0;
  }

  // --- Run once on page load ---
  getVisibleAdjustedPrice();

  // --- Set up MutationObserver to detect DOM changes ---
  const target = document.querySelector('.main__cart__item-sub--subtotal-adjust');
  if (target) {
    const observer = new MutationObserver(() => {
      // Wait a moment for DOM to finish updating
      setTimeout(getVisibleAdjustedPrice, 100);
    });

    observer.observe(target, {
      childList: true,       // detect when children (<sup>) update
      characterData: true,   // detect text content changes
      subtree: true          // watch inside <sup>
    });
  }

  // --- Also trigger manually on button clicks ---
  $(document).on('click', '.adjust-plus, .adjust-minus', function () {
    setTimeout(getVisibleAdjustedPrice, 200);
  });
   
});

